(function() {
    // Listenery na document/window sa rejestrowane z sygnalem AbortController.
    // Przy przeladowaniu sekcji w edytorze motywu stary kontroler jest przerywany,
    // wiec listenery nie duplikuja sie i nie wycieka pamiec.
    if (window.slrProductHeroAssetInitialized) return;
    window.slrProductHeroAssetInitialized = true;
    const cleanupKey = 'slrHeroCleanup';
    if (window[cleanupKey] && typeof window[cleanupKey].abort === 'function') {
      window[cleanupKey].abort();
    }
    const abortController = new AbortController();
    window[cleanupKey] = abortController;
    const listenerOptions = { signal: abortController.signal };

    function initHeroLock(root) {
      if (!root || root.dataset.heroLockInitialized === 'true') return;

      const checkbox = root.querySelector('[id^="slr-hero-agree-terms-"]');
      const overlay = root.querySelector('[id^="slr-hero-overlay-"]');
      const inner = root.querySelector('[id^="slr-hero-inner-"]');
      const error = root.querySelector('[id^="slr-hero-terms-error-"]');
      const widerrufToggle = root.querySelector('[data-hero-widerruf-toggle]');
      const widerrufPanel = root.querySelector('[data-hero-widerruf-panel]');
      const popupTarget = root.querySelector('[data-hero-terms-popup]');

      if (!checkbox || !overlay || !inner || !error) return;

      root.dataset.heroLockInitialized = 'true';

      function setPurchaseLockState() {
        if (checkbox.checked) {
          overlay.classList.add('hidden');
          overlay.setAttribute('aria-hidden', 'true');
          overlay.setAttribute('tabindex', '-1');
          inner.classList.add('active');
          inner.removeAttribute('inert');
          error.style.display = 'none';
          checkbox.setAttribute('aria-invalid', 'false');
        } else {
          overlay.classList.remove('hidden');
          overlay.setAttribute('aria-hidden', 'false');
          overlay.setAttribute('tabindex', '0');
          inner.classList.remove('active');
          inner.setAttribute('inert', '');
        }
      }

      function showTermsError() {
        error.style.display = 'block';
        checkbox.setAttribute('aria-invalid', 'true');
        checkbox.style.outline = '2px solid #ef3a12';
        checkbox.style.outlineOffset = '2px';

        if (typeof checkbox.focus === 'function') {
          checkbox.focus({ preventScroll: true });
        }

        window.setTimeout(function() {
          checkbox.style.outline = '';
          checkbox.style.outlineOffset = '';
        }, 1000);
      }

      function setWiderrufPanelState(isOpen) {
        if (!widerrufToggle || !widerrufPanel) return;

        widerrufToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        widerrufPanel.hidden = !isOpen;
        widerrufPanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }

      if (widerrufToggle && widerrufPanel) {
        widerrufToggle.addEventListener('click', function() {
          const isOpen = widerrufToggle.getAttribute('aria-expanded') === 'true';
          setWiderrufPanelState(!isOpen);
        });

        widerrufToggle.addEventListener('keydown', function(event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          const isOpen = widerrufToggle.getAttribute('aria-expanded') === 'true';
          setWiderrufPanelState(!isOpen);
        });

        setWiderrufPanelState(false);
      }

      if (popupTarget && popupTarget.dataset.heroTermsPopupReady !== 'true') {
        popupTarget.dataset.heroTermsPopupReady = 'true';

        const magnifier = popupTarget.querySelector('.slr-product-hero__magnifier');
        const popup = popupTarget.querySelector('.slr-product-hero__terms-popup');
        const closeBtn = popupTarget.querySelector('.slr-product-hero__terms-popup-close');

        function isTouchMode() {
          return window.matchMedia('(max-width: 768px), (hover: none), (pointer: coarse)').matches;
        }

        function showMagnifier() {
          popupTarget.classList.add('is-magnifier-visible');

          if (magnifier) {
            magnifier.setAttribute('aria-expanded', 'false');
          }
        }

        function hideMagnifier() {
          popupTarget.classList.remove('is-magnifier-visible');
        }

        function openPopup(event) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }

          popupTarget.classList.add('is-info-active');
          popupTarget.classList.add('is-magnifier-visible');

          if (popup) {
            popup.hidden = false;
          }

          if (magnifier) {
            magnifier.setAttribute('aria-expanded', 'true');
          }

          if (closeBtn && typeof closeBtn.focus === 'function') {
            closeBtn.focus({ preventScroll: true });
          }
        }

        function closePopup(event, returnFocus) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }

          popupTarget.classList.remove('is-info-active');

          if (popup) {
            popup.hidden = true;
          }

          if (magnifier) {
            magnifier.setAttribute('aria-expanded', 'false');

            if (returnFocus && typeof magnifier.focus === 'function') {
              magnifier.focus({ preventScroll: true });
            }
          }

          if (isTouchMode()) {
            hideMagnifier();
          }
        }

        function closeAll(returnFocus) {
          closePopup(null, returnFocus);
          hideMagnifier();
        }

        if (magnifier) {
          magnifier.addEventListener('click', openPopup);

          magnifier.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ' ') {
              openPopup(event);
            }
          });
        }

        if (closeBtn) {
          closeBtn.addEventListener('click', function(event) {
            closePopup(event, true);
          });

          closeBtn.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ' ') {
              closePopup(event, true);
            }
          });
        }

        if (popup) {
          popup.addEventListener('click', function(event) {
            event.stopPropagation();
          });

          popup.addEventListener('pointerdown', function(event) {
            event.stopPropagation();
          });
        }

        popupTarget.addEventListener('click', function(event) {
          if (!isTouchMode()) return;
          if (event.target.closest('.slr-product-hero__magnifier')) return;
          if (event.target.closest('.slr-product-hero__terms-popup')) return;
          if (event.target.closest('a')) return;

          if (event.target.closest('label')) {
            showMagnifier();
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          if (popupTarget.classList.contains('is-info-active')) {
            closePopup(null, false);
            return;
          }

          popupTarget.classList.toggle('is-magnifier-visible');
        });

        popupTarget.addEventListener('keydown', function(event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;

          if (document.activeElement === popupTarget) {
            event.preventDefault();
            event.stopPropagation();

            if (popupTarget.classList.contains('is-info-active')) {
              closePopup(null, true);
            } else if (popupTarget.classList.contains('is-magnifier-visible')) {
              openPopup(event);
            } else {
              showMagnifier();
            }
          }
        });

        document.addEventListener('click', function(event) {
          if (!popupTarget.contains(event.target)) {
            closeAll(false);
          }
        }, listenerOptions);

        document.addEventListener('pointerdown', function(event) {
          if (!popupTarget.contains(event.target)) {
            closeAll(false);
          }
        }, listenerOptions);

        document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape') {
            closeAll(true);
            setWiderrufPanelState(false);
          }
        }, listenerOptions);

        window.addEventListener('resize', function() {
          closeAll(false);
        }, listenerOptions);
      }

      overlay.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        showTermsError();
      });

      overlay.addEventListener('keydown', function(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();
        showTermsError();
      });

      checkbox.addEventListener('change', setPurchaseLockState);

      setPurchaseLockState();
    }

    function initAllHeroLocks(scope) {
      (scope || document).querySelectorAll('[data-product-hero-section]').forEach(initHeroLock);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initAllHeroLocks(document); }, listenerOptions);
    } else {
      initAllHeroLocks(document);
    }
    document.addEventListener('shopify:section:load', function(event) {
      const root = event.target.querySelector('[data-product-hero-section]');
      if (root) { root.dataset.heroLockInitialized = 'false'; initHeroLock(root); }
    }, listenerOptions);
  })();
